const baseSpoilerData = {};
export const SpoilerData = {
    fromJSON(object) {
        const message = Object.assign({}, baseSpoilerData);
        message.id = object.id !== undefined && object.id !== null ? String(object.id) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
};
//# sourceMappingURL=decoration_spoiler.js.map